import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { Block } from 'jsxstyle/preact'
import { connect } from 'unistore/preact'

import { useMap } from '../use-map'

const colorMatch = (color, point) => {
  try {
    const pointAttr = point.attributes.find((a) => a.id === color.attribute.id)

    if (!pointAttr) {
      return color.operand === 'not' || color.operand === 'not_contains'
    }

    if (color.attribute.type === 'boolean') {
      if (color.operand === 'eq') {
        return pointAttr.value === 'TRUE'
      } else {
        return pointAttr.value !== 'TRUE'
      }
    }
    if (color.attribute.type === 'text') {
      if (color.operand === 'eq') {
        return pointAttr.value === color.value
      }
      if (color.operand === 'not') {
        return pointAttr.value !== color.value
      }
      if (color.operand === 'contains') {
        console.log(pointAttr.value, typeof pointAttr.value)
        return pointAttr.value.toLowerCase().includes(color.value.toLowerCase())
      }
      if (color.operand === 'not_contains') {
        return !pointAttr.value.toLowerCase().includes(color.value.toLowerCase())
      }
    }
    if (color.attribute.type === 'number') {
      const expected = parseFloat(color.value)
      const actual = parseFloat(pointAttr.value)
      if (color.operand == 'eq') {
        return expected == actual
      }
      if (color.operand == 'not') {
        return expected != actual
      }
      if (color.operand == 'lt') {
        return actual < expected
      }
      if (color.operand == 'lte') {
        return actual <= expected
      }
      if (color.operand == 'gt') {
        return actual > expected
      }
      if (color.operand == 'gte') {
        return actual >= expected
      }
    }
  } catch (err) {
    console.warn(err)
  }
  return false
}

export const getColor = (project, point) => {
  for (let color of project.colors) {
    if (colorMatch(color, point)) {
      return color.color
    }
  }
  return project.defaultColor
}

const PointMap = ({ project, point, ...params }) => {
  const [mapRef, map] = useMap(project, {
    center: [point.lng, point.lat],
    zoom: point.zoom,
    layers: project.layers
  })

  const color = getColor(project, point)

  const { lat, lng, zoom, name } = point

  useEffect(() => {
    if (map) {
      const marker = new mapboxgl.Marker({
        color
      })
        .setLngLat([lng, lat])
        .setPopup(new mapboxgl.Popup({ closeButton: false }).setText(point.name))
        .addTo(map)
      map.setCenter([lng, lat])
      map.setZoom(zoom)
      return () => marker.remove()
    }
  }, [map, lat, lng, zoom, name, color])

  return <Block props={{ ref: mapRef }} background="var(--surface-alternative)" {...params} />
}

export default connect('project')(PointMap)
